// ========== 地下城配置 ==========
export const ROOM_TYPES = {
  battle:   { type:'battle',   icon:'⚔️', name:'战斗',     weight:35, desc:'前方有敌人的气息…' },
  elite:    { type:'elite',    icon:'👹', name:'精英战',   weight:12, desc:'强大的气息在逼近…' },
  treasure: { type:'treasure', icon:'💎', name:'宝藏',     weight:15, desc:'角落里似乎有东西在发光' },
  trap:     { type:'trap',     icon:'⚠️', name:'陷阱',      weight:10, desc:'地面有可疑的痕迹…' },
  rest:     { type:'rest',     icon:'🔥', name:'篝火',      weight:10, desc:'前方有温暖的篝火光芒' },
  mystery:  { type:'mystery',  icon:'❓', name:'神秘',      weight:10, desc:'一扇诡异的大门挡住了去路…' },
  shop:     { type:'shop',     icon:'🧳', name:'流浪商',   weight:8,  desc:'远处传来商人的叫卖声…' },
};

export const TRAVEL_EVENTS = [
  { id:'ambush',    name:'怪物伏击',  prob:0.15, icon:'👹', text:'黑暗中窜出一个黑影！',       effect:'combat' },
  { id:'gold_find', name:'发现金币',  prob:0.12, icon:'💰', text:'地上散落着几枚金币…',         effect:'gold',    value:{min:20, max:80} },
  { id:'herb',      name:'药草发现',  prob:0.10, icon:'🌿', text:'岩缝中长着一株发光药草！',   effect:'item',    value:'hp_potion_s' },
  { id:'trap_pit',  name:'陷坑触发',  prob:0.08, icon:'🕳️', text:'脚下的地面突然塌陷！',        effect:'hp_loss', value:{min:15, max:35} },
  { id:'echo',      name:'诡异回音',  prob:0.08, icon:'👻', text:'走廊中回荡着诡异的低语…',    effect:'spook',   value:'你感到一阵寒意，加快了脚步' },
  { id:'buff_rune', name:'古代符文',  prob:0.05, icon:'✨', text:'墙上刻着发光的古代符文！',    effect:'buff',    value:{atk:3, turns:1} },
  { id:'loot_pile', name:'前人遺物',  prob:0.05, icon:'🎒', text:'角落里有个破旧的背包…',      effect:'random_loot', value:null },
  { id:'none',      name:'平安无事',  prob:0.37, icon:'·',  text:'',                           effect:'none' },
];

// --- 宝藏房间开箱结果 ---
export const TREASURE_OUTCOMES = [
  { id:'normal_loot',  name:'普通宝藏', prob:0.45, icon:'💰', text:'宝箱中装满了金币——有些钱币上刻着精灵族的古老纹章。', goldMult:1.5, itemChance:0.3 },
  { id:'rich_loot',    name:'丰厚宝藏', prob:0.20, icon:'💎', text:'宝箱中金光闪闪！角落里有一卷烧焦的精灵卷轴，上面记录着大魔法阵的维护咒文。', goldMult:3.0, itemChance:0.6, tierBonus:1 },
  { id:'equip_loot',   name:'装备宝箱', prob:0.15, icon:'⚔️', text:'一件泛着微光的装备躺在宝箱中——可能是某位逝去冒险家的遗物。', goldMult:0.3, itemChance:1.0, tierBonus:2 },
  { id:'mimic',        name:'宝箱怪！', prob:0.08, icon:'👹', text:'宝箱突然张开血盆大口！紫色雾气从它的齿缝间喷出——连宝箱也被感染了！', goldMult:1.0, itemChance:0.5, mimic:true },
  { id:'cursed_loot',  name:'诅咒宝藏', prob:0.07, icon:'☠️', text:'宝箱散发着狄瑞吉瘟疫的紫色微光——里面的宝物和诅咒被毒素浸透。', goldMult:2.0, itemChance:0.4, curse:true },
  { id:'empty',        name:'空宝箱',   prob:0.05, icon:'📦', text:'空宝箱的底部刻着精灵语：「对不起，我们来晚了。」', goldMult:0, itemChance:0 },
];

// --- 精英怪词缀 ---
export const ELITE_MODIFIERS = [
  { id:'frenzy',    name:'狂暴',    icon:'🔴',  text:'双眼血红，攻击力大幅提升',   atkMult:1.5, hpMult:1.0, spdMult:1.0, dropBonus:0.3 },
  { id:'regen',     name:'再生',    icon:'💚',  text:'伤口在缓慢愈合',              atkMult:1.0, hpMult:1.3, spdMult:1.0, dropBonus:0.2, regen:5 },
  { id:'armored',   name:'钢甲',    icon:'🛡️',  text:'皮肤硬如钢铁',                 atkMult:1.0, hpMult:1.0, defBonus:12, spdMult:0.8, dropBonus:0.25 },
  { id:'swift',     name:'迅捷',    icon:'💨',  text:'动作快如闪电',                 atkMult:1.2, hpMult:1.0, spdMult:1.4, dropBonus:0.20 },
  { id:'toxic',     name:'剧毒',    icon:'☠️',  text:'利爪上淬满毒液',              atkMult:1.2, hpMult:1.0, spdMult:1.0, poison:true, dropBonus:0.25 },
  { id:'cursed',    name:'诅咒',    icon:'👻',  text:'被黑暗力量侵蚀',              atkMult:1.3, hpMult:0.8, spdMult:1.0, curse:true, dropBonus:0.30 },
  { id:'giant',     name:'巨型',    icon:'🦍',  text:'体型异常庞大',                 atkMult:1.3, hpMult:1.6, spdMult:0.7, dropBonus:0.35 },
  { id:'phantom',   name:'幻影',    icon:'💫',  text:'身形时隐时现',                 atkMult:1.0, hpMult:1.0, spdMult:1.2, evade:0.20, dropBonus:0.25 },
];

// --- 地下城全局修饰符 ---
export const DUNGEON_MODIFIERS = [
  { id:'gold_rush',    name:'金币丰收',   icon:'💰', desc:'整个地下城金币掉落+50%',         goldMult:1.5, expMult:1.0, dropMult:1.0, atkMult:1.0, hpMult:1.0 },
  { id:'monster_rage', name:'魔物狂暴',   icon:'🔴', desc:'所有怪物攻击力+20%',              goldMult:1.0, expMult:1.3, dropMult:1.2, atkMult:1.2, hpMult:1.1 },
  { id:'lucky_day',    name:'幸运之日',   icon:'🍀', desc:'稀有装备掉率翻倍',                goldMult:1.2, expMult:1.1, dropMult:2.0, atkMult:1.0, hpMult:1.0 },
  { id:'famine',       name:'物资短缺',   icon:'🏜️', desc:'金币掉落-30%，但经验+50%',        goldMult:0.7, expMult:1.5, dropMult:1.0, atkMult:1.0, hpMult:1.0 },
  { id:'weaken',       name:'怪物虚弱',   icon:'💚', desc:'所有怪物HP-15%',                  goldMult:1.0, expMult:0.9, dropMult:0.8, atkMult:1.0, hpMult:0.85 },
  { id:'trap_master',  name:'陷阱大师',   icon:'⚠️', desc:'陷阱事件概率翻倍，但奖励+40%',    goldMult:1.4, expMult:1.2, dropMult:1.4, atkMult:1.0, hpMult:1.0, trapBonus:true },
  { id:'darkness',     name:'黑暗笼罩',   icon:'🌑', desc:'视野受限，但经验+30%',             goldMult:1.0, expMult:1.3, dropMult:1.1, atkMult:1.0, hpMult:1.0 },
  { id:'hero_soul',    name:'英雄之魂',   icon:'👼', desc:'玩家攻击力+15%',                   goldMult:1.0, expMult:1.0, dropMult:1.0, playerAtkBonus:1.15, hpMult:1.0 },
];

// --- 神秘房间结果 ---
export const MYSTERY_OUTCOMES = [
  { id:'bless',    name:'精灵守护', prob:0.20, icon:'✨', text:'墙壁上的精灵符文突然发光——一道圣光笼罩了你！HP和MP完全恢复。', effect:'full_heal' },
  { id:'summon',   name:'被感染的守卫', prob:0.25, icon:'👹', text:'门后冲出一只被瘟疫感染的古老守卫——它已经等了十年。', effect:'combat' },
  { id:'loot',     name:'前人遗物', prob:0.20, icon:'💎', text:'房间中堆满了冒险家前辈留下的物资——有人在这里战斗过，却没能走出去。', effect:'big_loot' },
  { id:'skill',    name:'古代战技', prob:0.15, icon:'📜', text:'墙壁上刻着精灵战士留下的剑术图谱——虽历大火仍清晰可辨。', effect:'perm_buff', value:{atk:2, def:1} },
  { id:'portal',   name:'空间裂隙', prob:0.10, icon:'🌀', text:'空气中裂开一道紫色裂隙——瘟疫碎片扰乱了空间！你被传送了。', effect:'skip_room' },
  { id:'nothing',  name:'禁区',     prob:0.10, icon:'📦', text:'门后是一间被大火烧毁的精灵居所。什么也没剩下——除了墙壁上一行字：「原谅我们。」', effect:'none' },
];

export const ROOM_GEN_CONFIG = {
  minRooms: 5,
  maxRooms: 8,
  bossWeight: 0,        // Boss单独处理（最后）
  checkChance: 0.10,    // 技能检定房
  shrineChance: 0.08,   // 祭坛献祭房
  forkChance: 0.07,     // 分岔路口（财富/力量）
  prepBeforeBoss: true,  // Boss前准备室
  eliteChance: 0.12,
  treasureChance: 0.15,
  trapChance: 0.10,
  restChance: 0.10,
  mysteryChance: 0.10,
  shopChance: 0.08,
  battleFill: true,     // 剩余房间用战斗填充
};

// 简易伪随机数生成器
export function seededRandom(seed) {
  let s = seed;
  return function() {
    s = (s * 1664525 + 1013904223) & 0xFFFFFFFF;
    return (s >>> 0) / 0xFFFFFFFF;
  };
}
